import { EffectCreative, Navigation, Swiper } from 'swiper';
import 'swiper/swiper.scss';
import 'swiper/modules/effect-creative/effect-creative.scss';

document.addEventListener('DOMContentLoaded', () => {
    
    const thisIndex = function(elm) {
        let nodes = elm.parentNode.childNodes, node, i = 0, count = 0;
    
        while( (node = nodes.item(i++)) && node != elm ) {
            if( node.nodeType == 1 ) count++;            
        }
    
        return count;
    };

    const teams_desc = document.querySelector('.js-teamsDescSwiper');

    const init = () => {
        const team_nav = document.querySelector('.js-teamsNavSwiper');
        let mediaQuery = '(max-width: 768px)',
            mediaQueryList = window.matchMedia(mediaQuery),
            swiper_nav;
        
        const nav_carousel = () => {
            swiper_nav = new Swiper(team_nav, {
                modules: [Navigation],
                navigation: {
                    nextEl: team_nav.parentNode.querySelector('.swiper-button-next'),
                    prevEl: team_nav.parentNode.querySelector('.swiper-button-prev')
                },
                on: {
                    slideChange: (e) => {
                        let currentSlide = e.slides[e.realIndex]
                        swiper_teams.slideTo(thisIndex(currentSlide))
                    },
                },
                speed: 800
            });
        }
        
        const swiper_teams = new Swiper(teams_desc, {
            autoHeight: true,
            effect: "creative",
            breakpoints: {
                769: {
                    allowTouchMove: 0,
                    creativeEffect: {
                        prev: {
                           translate: [0, "100%", 0],
                           opacity: 0
                        },
                        next: {
                           translate: [0, "-20%", -1],
                           opacity: 0
                        },
                    },
                },
            },
            creativeEffect: {
                prev: {
                   translate: ["-100%", 0, 0],
                   opacity: 0
                },
                next: {
                   translate: ["20%", 0, -1],
                   opacity: 0
                },
            },
            modules: [EffectCreative],
            on: {
                slideChange: (e) => {
                    if (window.innerWidth <= 768) {
                        let currentSlide = e.slides[e.realIndex]
                        swiper_nav.slideTo(thisIndex(currentSlide))
                    }
                },
            },
            speed: 800,
        });
        
        team_nav.querySelectorAll('.swiper-slide').forEach(item => {
            item.addEventListener('click', function() {
                team_nav.querySelectorAll('.swiper-slide').forEach(item => {
                    item.classList.remove('swiper-slide-active');
                })

                item.classList.add('swiper-slide-active');
                swiper_teams.slideTo(thisIndex(item))
            })
        })
        
        mediaQueryList.addEventListener('change', event => {
            event.matches ? nav_carousel() : swiper_nav.destroy();
        })
        
        mediaQueryList.matches ? nav_carousel() : false;
    }

    teams_desc ? init() : false;
    
}, false);
